import { Typography, useTheme } from '@lingoda/ui';
import type { PropsWithChildren } from 'react';

export const ClassListItemHeader = ({ children }: PropsWithChildren<unknown>) => {
    const theme = useTheme();

    return (
        <Typography
            variant="subtitle2"
            htmlColor={theme.colors.text.progress}
            sx={{ width: 64, mr: 2 }}
        >
            {children}
        </Typography>
    );
};
